// import { useState, useEffect } from "react";
// import { Form, Button, Card, Col, Row } from "react-bootstrap";
// import { FaUpload } from "react-icons/fa";
// import Swal from "sweetalert2";
// import { useParams, useNavigate } from "react-router-dom";
// import axios from "axios";

// export default function CourseLandingPage({ courseId }) {
//   const navigate = useNavigate();
//   const [courseTitle, setCourseTitle] = useState("");
//   const [courseSubtitle, setCourseSubtitle] = useState("");
//   const [courseDescription, setCourseDescription] = useState("");
//   const [courseImage, setCourseImage] = useState(null);
//   const [promoVideo, setPromoVideo] = useState(null);
//   const [price, setPrice] = useState("");
//   const [categories, setCategories] = useState([]);
//   const [allCategories, setAllCategories] = useState([]); // All available categories
//   const [selectedCategory, setSelectedCategory] = useState(""); // Currently selected category
//   const token = localStorage.getItem("jwttoken");
//   const [isLoading, setIsLoading] = useState(false);

//   useEffect(() => {
//     console.log("Received courseId:", courseId);
//     if (courseId) {
//       fetchCourseDetails();
//     }
//     fetchAllCategories(); // Fetch all available categories
//   }, [courseId]);

//   const fetchAllCategories = async () => {
//     try {
//       const response = await axios.get(
//         "https://kaasbackend.vetrinahealthcare.com/lms/categories/",
//         {
//           headers: { Authorization: `Bearer ${token}` },
//         }
//       );
//       setAllCategories(response.data);
//     } catch (error) {
//       console.error("Error fetching categories:", error);
//     }
//   };

//   const handleFileUpload = (event, setFileString) => {
//     const file = event.target.files[0];
//     if (file) {
//       const reader = new FileReader();
//       reader.readAsDataURL(file);
//       reader.onload = () => {
//         console.log("Base64 File String:", reader.result);
//         setFileString(reader.result);
//       };
//       reader.onerror = (error) => {
//         console.error("Error converting file to Base64:", error);
//       };
//     }
//   };

//   const fetchCourseDetails = async () => {
//     try {
//       const response = await axios.get(
//         `https://kaasbackend.vetrinahealthcare.com/lms/courses/${courseId}/`,
//         {
//           headers: { Authorization: `Bearer ${token}` },
//         }
//       );
//       const courseData = response.data;
//       setCourseTitle(courseData.title || "");
//       setCourseSubtitle(courseData.subtitle || "");
//       setCourseDescription(courseData.description || "");
//       setPrice(courseData.price || "");
//       setCourseImage(courseData.cover_img || null);
//       setPromoVideo(courseData.trailer || null);
//       setCategories(courseData.categories || []);
//       if (courseData.categories && courseData.categories.length > 0) {
//         setSelectedCategory(courseData.categories[0]);
//       }
//     } catch (error) {
//       console.error("Error fetching course:", error);
//     }
//   };

//   const handleCategoryChange = (e) => {
//     setSelectedCategory(e.target.value);
//   };

//   const addCategory = () => {
//     if (selectedCategory && !categories.includes(selectedCategory)) {
//       setCategories([...categories, selectedCategory]);
//       setSelectedCategory("");
//     }
//   };

//   const removeCategory = (categoryToRemove) => {
//     setCategories(categories.filter(category => category !== categoryToRemove));
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setIsLoading(true);
//     const updatedData = {
//       title: courseTitle,
//       subtitle: courseSubtitle,
//       description: courseDescription,
//       price: price,
//       cover_img: courseImage || "",
//       trailer: promoVideo || "",
//       categories: categories,
//     };

//     try {
//       await axios.patch(
//         `https://kaasbackend.vetrinahealthcare.com/lms/courses/${courseId}/`,
//         updatedData,
//         {
//           headers: {
//             "Content-Type": "application/json",
//             Authorization: `Bearer ${token}`,
//           },
//         }
//       );
//       Swal.fire({
//         title: "Success!",
//         text: "Course updated successfully",
//         icon: "success",
//         timer: 1500,
//         timerProgressBar: true,
//         showConfirmButton: false,
//       }).then(() => {
//         navigate(`/Course/${courseId}`);
//       });
//     } catch (error) {
//       console.error("Error updating course:", error);
//       Swal.fire({
//         title: "Error!",
//         text: "Failed to update course",
//         icon: "error",
//         confirmButtonText: "OK",
//       });
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   return (
//     <div className="p-4">
//       <h2 className="mb-4">Course Landing Page</h2>
//       <div className="mb-4">
//         <p className="text-muted">
//           Your course landing page is crucial to your success on Udemy. If it's
//           done right, it can also help you gain visibility in search engines
//           like Google. As you complete this section, think about creating a
//           compelling Course Landing Page that demonstrates why someone would
//           want to enroll in your course. Learn more about{" "}
//           <a href=" " className="text-primary">
//             creating your course landing page
//           </a>{" "}
//           and{" "}
//           <a href=" " className="text-primary">
//             course title standards
//           </a>
//           .
//         </p>
//       </div>
//       <Form onSubmit={handleSubmit}>
//         <Form.Group className="mb-4">
//           <Form.Label className="fw-bold">Course Title</Form.Label>
//           <Form.Control
//             type="text"
//             value={courseTitle}
//             onChange={(e) => setCourseTitle(e.target.value)}
//           />
//         </Form.Group>
//         <Form.Group className="mb-4">
//           <Form.Label className="fw-bold">Course Description</Form.Label>
//           <Form.Control
//             as="textarea"
//             rows={6}
//             value={courseDescription}
//             onChange={(e) => setCourseDescription(e.target.value)}
//           />
//         </Form.Group>
//         <Form.Group className="mb-4">
//           <Form.Label className="fw-bold">Price</Form.Label>
//           <Form.Control
//             type="text"
//             value={price}
//             onChange={(e) => setPrice(e.target.value)}
//           />
//         </Form.Group>

//         <Form.Group className="mb-4">
//           <Form.Label className="fw-bold">Categories</Form.Label>
//           <div className="d-flex align-items-center mb-2">
//             <Form.Select
//               value={selectedCategory}
//               onChange={handleCategoryChange}
//               className="me-2"
//               style={{ maxWidth: "300px" }}
//             >
//               <option value="">Select a category</option>
//               {allCategories.map((category, index) => (
//                 <option key={index} value={category.name}>
//                   {category.name}
//                 </option>
//               ))}
//             </Form.Select>
//             <Button 
//               variant="outline-primary" 
//               onClick={addCategory}
//               disabled={!selectedCategory}
//             >
//               Add Category
//             </Button>
//           </div>
          
//           <div className="mt-2">
//             {categories.map((category, index) => (
//               <span key={index} className="badge bg-primary me-2 mb-2 p-2">
//                 {category}
//                 <button 
//                   type="button" 
//                   className="btn-close btn-close-white ms-2" 
//                   aria-label="Remove"
//                   onClick={() => removeCategory(category)}
//                   style={{ fontSize: '0.6rem' }}
//                 />
//               </span>
//             ))}
//           </div>
//         </Form.Group>

//         <Card className="p-3 mb-4 border-0">
//           <Row className="align-items-center">
//             <Col md={5} className="text-center">
//               {courseImage ? (
//                 <img
//                   src={courseImage}
//                   alt="Course"
//                   className="img-fluid rounded"
//                 />
//               ) : (
//                 <p>No Image</p>
//               )}
//             </Col>
//             <Col md={7}>
//               <Form.Control
//                 type="file"
//                 accept="image/*"
//                 hidden
//                 id="courseImageInput"
//                 onChange={(e) => handleFileUpload(e, setCourseImage)}
//               />
//               <label
//                 htmlFor="courseImageInput"
//                 className="btn btn-outline-primary"
//               >
//                 <FaUpload /> Upload Cover Image
//               </label>
//             </Col>
//           </Row>
//         </Card>

//         <Card className="p-3 mb-4 border-0">
//           <Row className="align-items-center">
//             <Col md={5} className="text-center">
//               {promoVideo ? (
//                 <video controls width="100%">
//                   <source src={promoVideo} type="video/mp4" />
//                   Your browser does not support the video tag.
//                 </video>
//               ) : (
//                 <p>No Promo Video</p>
//               )}
//             </Col>
//             <Col md={7}>
//               <Form.Control
//                 type="file"
//                 accept="video/*"
//                 hidden
//                 id="promoVideoInput"
//                 onChange={(e) => handleFileUpload(e, setPromoVideo)}
//               />
//               <label
//                 htmlFor="promoVideoInput"
//                 className="btn btn-outline-primary"
//               >
//                 <FaUpload /> Upload Promo Video
//               </label>
//             </Col>
//           </Row>
//         </Card>

//         <Button
//           type="submit"
//           variant="primary"
//           className="mt-4"
//           disabled={isLoading}
//         >
//           {isLoading ? (
//             <>
//               <span
//                 className="spinner-border spinner-border-sm me-2"
//                 role="status"
//                 aria-hidden="true"
//               ></span>
//               Updating...
//             </>
//           ) : (
//             "Update Course"
//           )}
//         </Button>
//       </Form>
//     </div>
//   );
// }


// import { useState, useEffect } from "react";
// import { Form, Button, Card, Col, Row, Badge } from "react-bootstrap";
// import { FaUpload } from "react-icons/fa";
// import Swal from "sweetalert2";
// import { useParams, useNavigate } from "react-router-dom";
// import axios from "axios";
// import Skeleton from "react-loading-skeleton";
// import "react-loading-skeleton/dist/skeleton.css";

// export default function CourseLandingPage({ courseId }) {
//   const navigate = useNavigate();
//   const [courseTitle, setCourseTitle] = useState("");
//   const [courseDescription, setCourseDescription] = useState("");
//   const [courseImage, setCourseImage] = useState(null);
//   const [promoVideo, setPromoVideo] = useState(null);
//   const [price, setPrice] = useState("");
//   const [categories, setCategories] = useState([]);
//   const token = localStorage.getItem("jwttoken");
//   const [isLoading, setIsLoading] = useState(true);
//   const [isSubmitting, setIsSubmitting] = useState(false);

//   useEffect(() => {
//     if (courseId) {
//       fetchCourseDetails();
//     }
//   }, [courseId]);

//   const fetchCourseDetails = async () => {
//     try {
//       const response = await axios.get(
//         `https://kaasbackend.vetrinahealthcare.com/lms/courses/${courseId}/`,
//         {
//           headers: { Authorization: `Bearer ${token}` },
//         }
//       );
//       const courseData = response.data;
//       setCourseTitle(courseData.title || "");
//       setCourseDescription(courseData.description || "");
//       setPrice(courseData.price || "");
//       setCourseImage(courseData.cover_img || null);
//       setPromoVideo(courseData.trailer || null);
//       setCategories(courseData.categories || []);
//     } catch (error) {
//       console.error("Error fetching course:", error);
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   const handleFileUpload = (event, setFileString) => {
//     const file = event.target.files[0];
//     if (file) {
//       const reader = new FileReader();
//       reader.readAsDataURL(file);
//       reader.onload = () => {
//         setFileString(reader.result);
//       };
//       reader.onerror = (error) => {
//         console.error("Error converting file to Base64:", error);
//       };
//     }
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setIsSubmitting(true);
//     const updatedData = {
//       title: courseTitle,
//       description: courseDescription,
//       price: price,
//       cover_img: courseImage || "",
//       trailer: promoVideo || "",
//     };
//     try {
//       await axios.patch(
//         `https://kaasbackend.vetrinahealthcare.com/lms/courses/${courseId}/`,
//         updatedData,
//         {
//           headers: {
//             "Content-Type": "application/json",
//             Authorization: `Bearer ${token}`,
//           },
//         }
//       );
//       Swal.fire({
//         title: "Success!",
//         text: "Course updated successfully",
//         icon: "success",
//         timer: 1500,
//         showConfirmButton: false,
//         background: "#f8f9fa",
//       }).then(() => {
//         navigate(`/Course/${courseId}`);
//       });
//     } catch (error) {
//       console.error("Error updating course:", error);
//       Swal.fire({
//         title: "Error!",
//         text: "Failed to update course",
//         icon: "error",
//         confirmButtonText: "OK",
//         background: "#f8f9fa",
//       });
//     } finally {
//       setIsSubmitting(false);
//     }
//   };

//   const styles = {
//     primaryButton: {
//       backgroundColor: "#ff6b35",
//       borderColor: "#ff6b35",
//     },
//     secondaryButton: {
//       backgroundColor: "#6e44ff",
//       borderColor: "#6e44ff",
//     },
//     cardHeader: {
//       backgroundColor: "#f8f9fa",
//       borderBottom: "2px solid #6e44ff",
//     },
//   };

//   return (
//     <div className="p-4" style={{ backgroundColor: "#f8f9fa", minHeight: "100vh" }}>
//       <Card className="border-0 shadow-sm mb-4">
//         <Card.Header style={styles.cardHeader}>
//           <h2 className="mb-0" style={{ color: "#6e44ff" }}>Course Landing Page</h2>
//         </Card.Header>
//         <Card.Body>
//           <p className="text-muted">
//             Your course landing page is crucial to your success on Udemy. If it's
//             done right, it can also help you gain visibility in search engines
//             like Google. As you complete this section, think about creating a
//             compelling Course Landing Page that demonstrates why someone would
//             want to enroll in your course. Learn more about{" "}
//             <a href=" " className="text-primary" style={{ color: '#ff6b35' }}>
//               creating your course landing page
//             </a>{" "}
//             and{" "}
//             <a href=" " className="text-primary" style={{ color: '#ff6b35' }}>
//               course title standards
//             </a>
//             .
//           </p>
//         </Card.Body>
//       </Card>

//       <Form onSubmit={handleSubmit}>
//         <Card className="border-0 shadow-sm mb-4">
//           <Card.Header style={styles.cardHeader}>
//             <h5 className="mb-0">Basic Information</h5>
//           </Card.Header>
//           <Card.Body>
//             <Form.Group className="mb-4">
//               <Form.Label className="fw-bold">Course Title</Form.Label>
//               {isLoading ? (
//                 <Skeleton height={40} />
//               ) : (
//                 <Form.Control
//                   type="text"
//                   value={courseTitle}
//                   onChange={(e) => setCourseTitle(e.target.value)}
//                 />
//               )}
//             </Form.Group>

//             <Form.Group className="mb-4">
//               <Form.Label className="fw-bold">Course Description</Form.Label>
//               {isLoading ? (
//                 <Skeleton height={100} />
//               ) : (
//                 <Form.Control
//                   as="textarea"
//                   rows={6}
//                   value={courseDescription}
//                   onChange={(e) => setCourseDescription(e.target.value)}
//                 />
//               )}
//             </Form.Group>

//             <Form.Group className="mb-4">
//               <Form.Label className="fw-bold">Price</Form.Label>
//               {isLoading ? (
//                 <Skeleton height={40} width={150} />
//               ) : (
//                 <Form.Control
//                   type="text"
//                   value={price}
//                   onChange={(e) => setPrice(e.target.value)}
//                 />
//               )}
//             </Form.Group>
//           </Card.Body>
//         </Card>

//         <Card className="border-0 shadow-sm mb-4">
//           <Card.Header style={styles.cardHeader}>
//             <h5 className="mb-0">Categories</h5>
//           </Card.Header>
//           <Card.Body>
//             {isLoading ? (
//               <Skeleton count={1} height={30} width={200} />
//             ) : (
//               <div className="d-flex flex-wrap gap-2">
//                 {categories.map((category, index) => (
//                   <Badge key={index} pill style={{ backgroundColor: "#6e44ff" }}>
//                     {category}
//                   </Badge>
//                 ))}
//               </div>
//             )}
//           </Card.Body>
//         </Card>

//         <Card className="border-0 shadow-sm mb-4">
//           <Card.Header style={styles.cardHeader}>
//             <h5 className="mb-0">Course Media</h5>
//           </Card.Header>
//           <Card.Body>
//             <Row className="align-items-center mb-4">
//               <Col md={5} className="text-center mb-3 mb-md-0">
//                 {isLoading ? (
//                   <Skeleton height={200} width="100%" />
//                 ) : courseImage ? (
//                   <img
//                     src={courseImage}
//                     alt="Course"
//                     className="img-fluid rounded shadow"
//                     style={{ maxHeight: "200px" }}
//                   />
//                 ) : (
//                   <div className="d-flex align-items-center justify-content-center bg-light rounded" style={{ height: "200px" }}>
//                     <p className="text-muted m-0">No Image</p>
//                   </div>
//                 )}
//               </Col>
//               <Col md={7}>
//                 <Form.Control
//                   type="file"
//                   accept="image/*"
//                   hidden
//                   id="courseImageInput"
//                   onChange={(e) => handleFileUpload(e, setCourseImage)}
//                 />
//                 <label htmlFor="courseImageInput" className="btn" style={styles.secondaryButton}>
//                   <FaUpload className="me-2" /> Upload Cover Image
//                 </label>
//               </Col>
//             </Row>

//             <Row className="align-items-center">
//               <Col md={5} className="text-center mb-3 mb-md-0">
//                 {isLoading ? (
//                   <Skeleton height={200} width="100%" />
//                 ) : promoVideo ? (
//                   <video controls width="100%" className="rounded shadow" style={{ maxHeight: "200px" }}>
//                     <source src={promoVideo} type="video/mp4" />
//                     Your browser does not support the video tag.
//                   </video>
//                 ) : (
//                   <div className="d-flex align-items-center justify-content-center bg-light rounded" style={{ height: "200px" }}>
//                     <p className="text-muted m-0">No Promo Video</p>
//                   </div>
//                 )}
//               </Col>
//               <Col md={7}>
//                 <Form.Control
//                   type="file"
//                   accept="video/*"
//                   hidden
//                   id="promoVideoInput"
//                   onChange={(e) => handleFileUpload(e, setPromoVideo)}
//                 />
//                 <label htmlFor="promoVideoInput" className="btn" style={styles.secondaryButton}>
//                   <FaUpload className="me-2" /> Upload Promo Video
//                 </label>
//               </Col>
//             </Row>
//           </Card.Body>
//         </Card>

//         <div className="d-flex justify-content-end">
//           <Button
//             type="submit"
//             className="mt-4"
//             style={styles.primaryButton}
//             disabled={isSubmitting}
//           >
//             {isSubmitting ? (
//               <>
//                 <span className="spinner-border spinner-border-sm me-2"></span>
//                 Updating...
//               </>
//             ) : (
//               "Update Course"
//             )}
//           </Button>
//         </div>
//       </Form>
//     </div>
//   );
// }

import { useState, useEffect } from "react";
import { Form, Button, Card, Col, Row, Badge, Spinner } from "react-bootstrap";
import { FaUpload, FaCheck, FaEdit, FaTimes } from "react-icons/fa";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

export default function CourseLandingPage({ courseId }) {
  const navigate = useNavigate();
  const [courseTitle, setCourseTitle] = useState("");
  const [courseDescription, setCourseDescription] = useState("");
  const [courseImage, setCourseImage] = useState(null);
  const [promoVideo, setPromoVideo] = useState(null);
  const [price, setPrice] = useState("");
  const [categories, setCategories] = useState([]);
  const token = localStorage.getItem("jwttoken");

  const [isLoading, setIsLoading] = useState(true);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isImageUploading, setIsImageUploading] = useState(false);
  const [isVideoUploading, setIsVideoUploading] = useState(false);
  const [imageUploadSuccess, setImageUploadSuccess] = useState(false);
  const [videoUploadSuccess, setVideoUploadSuccess] = useState(false);
  const [imageFile, setImageFile] = useState(null);
  const [videoFile, setVideoFile] = useState(null);
  const [isEditMode, setIsEditMode] = useState(false);

  useEffect(() => {
    if (courseId) {
      fetchCourseDetails();
    }
  }, [courseId]);

  const fetchCourseDetails = async () => {
    try {
      const response = await axios.get(
        `https://kaasbackend.vetrinahealthcare.com/lms/courses/${courseId}/`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      const courseData = response.data;
      setCourseTitle(courseData.title || "");
      setCourseDescription(courseData.description || "");
      setPrice(courseData.price !== undefined && courseData.price !== null ? String(courseData.price) : "");
      setCourseImage(courseData.cover_img || null);
      setPromoVideo(courseData.trailer || null);
      setCategories(courseData.categories || []);
    } catch (error) {
      console.error("Error fetching course:", error);
      Swal.fire({
        title: "Error!",
        text: "Failed to load course details",
        icon: "error",
        confirmButtonText: "OK",
        background: "#f8f9fa",
      });
    } finally {
      setIsLoading(false);
    }
  };

  const handleFileUpload = async (event, setFile, setFileObj, setIsUploading, setUploadSuccess) => {
    const file = event.target.files[0];
    if (!file) return;

    setIsUploading(true);
    setUploadSuccess(false);

    try {
      setFileObj(file);
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        setFile(reader.result);
        setIsUploading(false);
        setUploadSuccess(true);
        setTimeout(() => setUploadSuccess(false), 3000);
      };
      reader.onerror = (error) => {
        console.error("Error converting file to Base64:", error);
        setIsUploading(false);
        Swal.fire({
          title: "Upload Failed!",
          text: "There was an error processing your file",
          icon: "error",
          timer: 2000,
          showConfirmButton: false,
          background: "#f8f9fa",
        });
      };
    } catch (error) {
      console.error("Upload error:", error);
      setIsUploading(false);
    }
  };

  const handlePriceChange = (e) => {
    const value = e.target.value;
    const numericValue = value.replace(/[^0-9]/g, "");
    setPrice(numericValue ? `₹${numericValue}` : "");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    const numericPrice = price.replace(/[^0-9]/g, "");

    const formData = new FormData();
    formData.append("title", courseTitle);
    formData.append("description", courseDescription);
    formData.append("price", numericPrice);

    if (imageFile) formData.append("cover_img", imageFile);
    if (videoFile) formData.append("trailer", videoFile);

    try {
      await axios.patch(
        `https://kaasbackend.vetrinahealthcare.com/lms/courses/${courseId}/`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      Swal.fire({
        title: "Success!",
        text: "Course updated successfully",
        icon: "success",
        timer: 1500,
        showConfirmButton: false,
        background: "#f8f9fa",
      }).then(() => {
        setIsEditMode(false);
        fetchCourseDetails();
      });
    } catch (error) {
      console.error("Error updating course:", error);
      Swal.fire({
        title: "Error!",
        text: error.response?.data?.message || "Failed to update course",
        icon: "error",
        confirmButtonText: "OK",
        background: "#f8f9fa",
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  const styles = {
    primaryButton: {
      backgroundColor: "#ff6b35",
      borderColor: "#ff6b35",
      minWidth: "150px",
    },
    secondaryButton: {
      backgroundColor: "#6e44ff",
      borderColor: "#6e44ff",
      minWidth: "200px",
    },
    cardHeader: {
      backgroundColor: "#f8f9fa",
      borderBottom: "2px solid #6e44ff",
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
    },
    uploadButton: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      gap: "8px",
    },
  };

  return (
    <div className="p-4" style={{ backgroundColor: "#f8f9fa", minHeight: "100vh" }}>
      {/* --- Course Landing Page Info --- */}
      <Card className="border-0 shadow-sm mb-4">
        <Card.Header style={{ ...styles.cardHeader, justifyContent: "flex-start" }}>
          <h2 className="mb-0 me-2" style={{ color: "#6e44ff" }}>
            Course Landing Page
          </h2>
        </Card.Header>
        <Card.Body>
          <p className="text-muted mb-0">
            Your course landing page is crucial to your success. If it's done right, it can help you gain visibility
            in search engines like Google. Create a compelling landing page that demonstrates why someone should enroll.
          </p>
        </Card.Body>
      </Card>

      {/* --- Editable Form --- */}
      <Form onSubmit={handleSubmit}>
        {/* --- Basic Information --- */}
        <Card className="border-0 shadow-sm mb-4">
          <Card.Header style={styles.cardHeader}>
            <h5 className="mb-0">Basic Information</h5>
            {!isLoading && (
              <Button
                variant={isEditMode ? "outline-danger" : "outline-primary"}
                size="sm"
                onClick={() => setIsEditMode(!isEditMode)}
              >
                {isEditMode ? (
                  <>
                    <FaTimes className="me-2" /> Cancel Edit
                  </>
                ) : (
                  <>
                    <FaEdit className="me-2" /> Edit
                  </>
                )}
              </Button>
            )}
          </Card.Header>

          <Card.Body>
            <Form.Group className="mb-4">
              <Form.Label className="fw-bold">Course Title</Form.Label>
              {isLoading ? (
                <Skeleton height={40} />
              ) : (
                <Form.Control
                  type="text"
                  value={courseTitle}
                  readOnly={!isEditMode}
                  onChange={(e) => setCourseTitle(e.target.value)}
                  required
                />
              )}
            </Form.Group>

            <Form.Group className="mb-4">
              <Form.Label className="fw-bold">Course Description</Form.Label>
              {isLoading ? (
                <Skeleton height={100} />
              ) : (
                <Form.Control
                  as="textarea"
                  rows={6}
                  value={courseDescription}
                  readOnly={!isEditMode}
                  onChange={(e) => setCourseDescription(e.target.value)}
                  required
                />
              )}
            </Form.Group>

            <Form.Group className="mb-4">
              <Form.Label className="fw-bold">Price (INR)</Form.Label>
              {isLoading ? (
                <Skeleton height={40} width={150} />
              ) : (
                <Form.Control
                  type="text"
                  value={price}
                  readOnly={!isEditMode}
                  onChange={handlePriceChange}
                  required
                />
              )}
            </Form.Group>
          </Card.Body>
        </Card>

        {/* --- Categories --- */}
        <Card className="border-0 shadow-sm mb-4">
          <Card.Header style={styles.cardHeader}>
            <h5 className="mb-0">Categories</h5>
          </Card.Header>
          <Card.Body>
            {isLoading ? (
              <Skeleton count={1} height={30} width={200} />
            ) : (
              <div className="d-flex flex-wrap gap-2">
                {categories.length > 0 ? (
                  categories.map((category, index) => (
                    <Badge key={index} pill style={{ backgroundColor: "#6e44ff" }}>
                      {category}
                    </Badge>
                  ))
                ) : (
                  <span className="text-muted">No categories assigned</span>
                )}
              </div>
            )}
          </Card.Body>
        </Card>

        {/* --- Course Media --- */}
        <Card className="border-0 shadow-sm mb-4">
          <Card.Header style={styles.cardHeader}>
            <h5 className="mb-0">Course Media</h5>
          </Card.Header>
          <Card.Body>
            {/* --- Image Upload --- */}
            <Row className="align-items-center mb-4">
              <Col md={5} className="text-center mb-3 mb-md-0">
                {isLoading ? (
                  <Skeleton height={200} width="100%" />
                ) : courseImage ? (
                  <div className="position-relative">
                    <img
                      src={courseImage}
                      alt="Course"
                      className="img-fluid rounded shadow"
                      style={{ maxHeight: "200px", objectFit: "cover" }}
                    />
                    {imageUploadSuccess && (
                      <div className="position-absolute top-0 end-0 m-2">
                        <div className="bg-success rounded-circle p-1">
                          <FaCheck className="text-white" />
                        </div>
                      </div>
                    )}
                  </div>
                ) : (
                  <div
                    className="d-flex align-items-center justify-content-center bg-light rounded"
                    style={{ height: "200px" }}
                  >
                    <p className="text-muted m-0">No Image</p>
                  </div>
                )}
              </Col>
              <Col md={7}>
                <Form.Control
                  type="file"
                  accept="image/*"
                  hidden
                  id="courseImageInput"
                  onChange={(e) =>
                    handleFileUpload(e, setCourseImage, setImageFile, setIsImageUploading, setImageUploadSuccess)
                  }
                  disabled={isImageUploading}
                />
                <label htmlFor="courseImageInput" className="btn text-white" style={styles.secondaryButton}>
                  <div style={styles.uploadButton}>
                    {isImageUploading ? (
                      <>
                        <Spinner animation="border" size="sm" className="me-2" />
                        Uploading...
                      </>
                    ) : (
                      <>
                        <FaUpload className="me-2" />{" "}
                        {courseImage ? "Change Cover Image" : "Upload Cover Image"}
                      </>
                    )}
                  </div>
                </label>
                <div className="mt-2 text-muted small">
                  Upload a high-quality cover image (recommended: 1280x720 pixels)
                </div>
              </Col>
            </Row>

            {/* --- Video Upload --- */}
            <Row className="align-items-center">
              <Col md={5} className="text-center mb-3 mb-md-0">
                {isLoading ? (
                  <Skeleton height={200} width="100%" />
                ) : promoVideo ? (
                  <div className="position-relative">
                    <video
                      controls
                      width="100%"
                      className="rounded shadow"
                      style={{ maxHeight: "200px" }}
                    >
                      <source src={promoVideo} type="video/mp4" />
                      Your browser does not support the video tag.
                    </video>
                    {videoUploadSuccess && (
                      <div className="position-absolute top-0 end-0 m-2">
                        <div className="bg-success rounded-circle p-1">
                          <FaCheck className="text-white" />
                        </div>
                      </div>
                    )}
                  </div>
                ) : (
                  <div
                    className="d-flex align-items-center justify-content-center bg-light rounded"
                    style={{ height: "200px" }}
                  >
                    <p className="text-muted m-0">No Promo Video</p>
                  </div>
                )}
              </Col>
              <Col md={7}>
                <Form.Control
                  type="file"
                  accept="video/*"
                  hidden
                  id="promoVideoInput"
                  onChange={(e) =>
                    handleFileUpload(e, setPromoVideo, setVideoFile, setIsVideoUploading, setVideoUploadSuccess)
                  }
                  disabled={isVideoUploading}
                />
                <label htmlFor="promoVideoInput" className="btn text-white" style={styles.secondaryButton}>
                  <div style={styles.uploadButton}>
                    {isVideoUploading ? (
                      <>
                        <Spinner animation="border" size="sm" className="me-2" />
                        Uploading...
                      </>
                    ) : (
                      <>
                        <FaUpload className="me-2" />{" "}
                        {promoVideo ? "Change Promo Video" : "Upload Promo Video"}
                      </>
                    )}
                  </div>
                </label>
                <div className="mt-2 text-muted small">
                  Upload a short promotional video (recommended: 1–2 minutes)
                </div>
              </Col>
            </Row>
          </Card.Body>
        </Card>

        {/* --- Update Button --- */}
        {isEditMode && (
          <div className="d-flex justify-content-end gap-3">
            <Button
              variant="outline-secondary"
              className="mt-4"
              onClick={() => setIsEditMode(false)}
              disabled={isSubmitting}
            >
              Cancel
            </Button>
            <Button
              type="submit"
              className="mt-4 text-white"
              style={styles.primaryButton}
              disabled={isSubmitting || isLoading}
            >
              {isSubmitting ? (
                <>
                  <Spinner animation="border" size="sm" className="me-2" />
                  Updating...
                </>
              ) : (
                "Update Course"
              )}
            </Button>
          </div>
        )}
      </Form>
    </div>
  );
}
